    angular.module('qkr').controller('OutletModalDialogController',
        ($scope, $uibModalInstance, utils, userAction, outlet) => {
            const vm = $scope;

            vm.userAction = userAction;
            vm.outlet = outlet;
            vm.saving = false;
            vm.form = {};

            const init = function () {
                if (vm.userAction === 'edit') {
                    if (!utils.hasNoValue(vm.outlet.name)) {
                        vm.form.outletname = vm.outlet.name;
                    }
                    vm.form.contactDetails = {};
                    if (vm.outlet.contactDetails) {
                        const contactDetails = vm.outlet.contactDetails;
                        const c = vm.form.contactDetails;
                        if (!utils.hasNoValue(contactDetails.addressLine1)) {
                            c.addressLine1 = contactDetails.addressLine1;
                        }
                        if (!utils.hasNoValue(contactDetails.addressLine2)) {
                            c.addressLine2 = contactDetails.addressLine2;
                        }
                        if (!utils.hasNoValue(contactDetails.addressLine3)) {
                            c.addressLine3 = contactDetails.addressLine3;
                        }
                        if (!utils.hasNoValue(contactDetails.city)) {
                            c.city = contactDetails.city;
                        }
                        if (!utils.hasNoValue(contactDetails.state)) {
                            c.state = contactDetails.state;
                        }
                        if (!utils.hasNoValue(contactDetails.country)) {
                            c.country = contactDetails.country;
                        }

                        if (!utils.hasNoValue(contactDetails.postalcode)) {
                            c.postalcode = contactDetails.postalcode;
                        }
                        if (!utils.hasNoValue(contactDetails.phoneNumber)) {
                            c.phoneNumber = contactDetails.phoneNumber;
                        }
                        if (!utils.hasNoValue(contactDetails.email)) {
                            c.email = contactDetails.email;
                        }
                        if (!utils.hasNoValue(contactDetails.website)) {
                            c.website = contactDetails.website;
                        }
                        if (!utils.hasNoValue(contactDetails.twitterAccount)) {
                            c.twitterAccount = contactDetails.twitterAccount;
                        }
                    }
                }
            };

            vm.cancel = function() {
                $uibModalInstance.close('cancel');
            };

            init();
        });



// WEBPACK FOOTER //
// ./src/controllers/modal/outlet.edit.controller.js